import React from "react";

const FooterLinkHeaders = ({ text }) => {
	return (
		<>
			<h1 className="text-gray-100 text-xl font-bold pt-7 pb-5 lg:pt-0">{text}</h1>
		</>
	);
};

export default FooterLinkHeaders;
